import type { Article } from '@/domain/Models';

export function resumablePosition(article: Article): number {
  if (article.completed || article.lastPositionMs <= 0) return 0;
  return article.durationMs - article.lastPositionMs > 1000 ? article.lastPositionMs : 0;
}

export function nextSequentialArticle(articles: Article[], articleId: string): Article | null {
  const index = articles.findIndex((article) => article.id === articleId);
  return index >= 0 ? (articles[index + 1] ?? null) : null;
}
